/**
 cate and subcate data store
 */
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export const photo_gallery = {
    namespaced: true,
    state: {
        galleryItem: [],
        filterType: "",
        start: 0,
        limit: 9,
        total: 0,
        filterList: [],
        paginationList: [],
        currentPaginationNum: 1,
        paginationListVisible: [],
        galleryItemDetails: []
    },
    mutations: {
        setGalleryItem(state, payload) {
            state.galleryItem = payload;
            state.galleryItemDetails = [];
            
            const arr = [];
            state.galleryItem.forEach(function(item, key) {
                let path = item.general.coverage;
                var img = new Image();
                img.src = window.location.origin+path;
                state.galleryItemDetails.push({
                    src: window.location.origin+path
                });
                img.onload = function() {
                    state.galleryItemDetails[key].w = img.naturalWidth
                    state.galleryItemDetails[key].h = img.naturalHeight
                }
            });
        },
        setFilterType(state, payload) {
            state.filterType = payload
        },
        setStart(state, payload) {
            state.start = payload
        },
        setTotal(state, payload) {
            state.total = payload
        },
        setFilterList(state, payload) {
            state.filterList = payload
        },
        setPaginationList(state, total) {

            state.paginationList = [];
            state.paginationListVisible = [];

            if (total > 9) {

                let num = total / 9;

                for (var i = 1; num >= i; i++) {
                    state.paginationList.push(i);

                    if (i <= 6) {
                        state.paginationListVisible.push(i);
                    }
                }
            }


        },
        setCurrentPaginationNum(state, payload) {
            state.currentPaginationNum = payload
        },
        setPaginationListVisible(state, payload) {
            state.paginationListVisible = payload
        }
    },
    getters: {}
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/photo_gallery.js